import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-detail-weblink',
    templateUrl: './detail-weblink.component.html',
    styleUrls: ['./detail-weblink.component.scss'],
    standalone: false,
})
export class DetailWeblinkComponent {
    @Input()
    public title?: string;

    @Input()
    public linkLabel?: string;

    @Input()
    public ariaLabel?: string;

    @Input()
    public outlined = false;

    public safeLink: SafeUrl | undefined;

    private _link: string | undefined;

    constructor(
        private readonly _domSanitizer: DomSanitizer,
    ) { }

    public get link(): string | undefined {
        return this._link;
    }

    @Input()
    public set link(link: string | undefined) {
        this._link = link;

        if (this._link) {
            this.safeLink = link && this._domSanitizer.bypassSecurityTrustUrl(this._sanitizeUrl(this._link));
        }
    }

    protected _sanitizeUrl(url: string): string {
        if (url.startsWith('http://') || url.startsWith('https://')) {
            return url;
        }
        return 'http://' + url;
    }

}
